import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9jdg5bykvm: FaireBrandEntity = {
  token: "b_9jdg5bykvm",
  type: "brand",
  name: "Rat Boi",
  avatarUrl:
    "https://cdn.faire.com/fastly/5af794a54032c095ed5bed2a6b70e4a3b21026d5f9ebb7489731565f20fbcd94.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fb03f9541b9d2e5d003b1e504d9f983440105e49e03237f6c7900f8f49ebc299.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5af794a54032c095ed5bed2a6b70e4a3b21026d5f9ebb7489731565f20fbcd94.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fb03f9541b9d2e5d003b1e504d9f983440105e49e03237f6c7900f8f49ebc299.jpeg",
  location: "Ventura, CA, USA",
  minimumOrderDollars: 693,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "RAT BOI is a female-owned small business specializing in high quality, ethically made cotton basics and apparel.  Each piece features our signature lace elastic trim and satin rose – both of which have become hallmarks of our brand.  What started as a small business with our founder, Alexa, sewing scrunchies and one of a kind upcycled pieces in her garage, turned into a growing brand with increasing demand.  After a long process searching for and vetting partners in our own backyard, we proudly moved RAT BOI's production from the garage to a family-run factory in Los Angeles where our highly skilled sewers receive fair wages to make your garments.  From day one, we have offered inclusive sizing and create our styles with every body in mind.  We are committed to making only what we know we will sell, and pricing our pieces based on what it costs us to make them rather than needlessly marking up prices and depending on seasonal sales to move surplus inventory.  At RAT BOI there are no hidden costs in the form of labor exploitation or low quality materials as with most fast fashion brands. Our people and planet prioritized business model supports the slow fashion movement and contributes to a more sustainable future in the apparel industry so you can keep your individual style with a clean conscience.  We thank you for joining us in prioritizing the planet and our future. It looks good on you. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.498Z",
    importedBy: "entity-db-cli",
  },
};
